const defaultContent = {
  "hero": {
    "line1": {
      "it": "Dall'energia",
      "en": "From energy"
    },
    "line2": {
      "it": "acquistata",
      "en": "purchased"
    },
    "line3": {
      "it": "all'energia",
      "en": "to energy"
    },
    "line4": {
      "it": "governata.",
      "en": "governed."
    },
    "subtitle": {
      "it": "Dalla lettura dei consumi alla regia operativa: un partner che coordina strategie, fornitori e delivery nel tempo."
    },
    "cta_primary": {
      "it": "Richiedi un'analisi",
      "en": "Request an analysis"
    },
    "cta_secondary": {
      "it": "Scopri il Metodo Ethic",
      "en": "Discover the Ethic Method"
    },
    "image": "https://images.unsplash.com/photo-1760246964044-1384f71665b9?fm=jpg&q=80&w=1600&auto=format&fit=crop"
  },
  "chapters": [
    {
      "num": "01",
      "title": {
        "it": "Dal prezzo alla strategia"
      },
      "new_lead": {
        "it": "Il prezzo conta. Ma da solo non basta."
      },
      "new_points": {
        "it": [
          "Analisi del profilo reale del cliente",
          "Strategie FIX / FLEX / MIX e scenari coerenti",
          "Supplier fit basato anche su credit check e modalità di pagamento",
          "Gestione e revisione della strategia nel tempo"
        ]
      },
      "old_lead": {
        "it": "Si parte dall'offerta disponibile."
      },
      "old_desc": {
        "it": "Il prodotto viene scelto prima di comprendere fino in fondo il profilo tecnico, finanziario e operativo del cliente."
      },
      "old_points": {
        "it": [
          "Confronto limitato al prezzo del momento",
          "Prodotti standard",
          "Profilazione incompleta",
          "Rinnovo gestito come evento isolato"
        ]
      }
    },
    {
      "num": "02",
      "title": {
        "it": "Dal consumo alla performance"
      },
      "new_lead": {
        "it": "L'energia più conveniente è anche quella che non serve consumare."
      },
      "new_points": {
        "it": [
          "Analisi di consumi e sprechi",
          "Ottimizzazione di impianti e processi",
          "Fotovoltaico, accumulo e produzione energetica",
          "Pompe di calore, HVAC, involucro e serramenti"
        ]
      },
      "old_lead": {
        "it": "Fornitura e consumi restano separati."
      },
      "old_desc": {
        "it": "Si cambia contratto senza verificare se il cliente stia consumando correttamente o se esistano interventi capaci di ridurre strutturalmente il fabbisogno."
      },
      "old_points": {
        "it": [
          "Contratto da una parte",
          "Impianti da un'altra",
          "Nessuna visione unitaria del consumo"
        ]
      }
    },
    {
      "num": "03",
      "title": {
        "it": "Dall'intervento all'investimento"
      },
      "new_lead": {
        "it": "Una tecnologia ha senso solo se funziona anche economicamente."
      },
      "new_points": {
        "it": [
          "Valutazione tecnica dell'intervento",
          "CAPEX, OPEX e ritorno economico",
          "Conto Termico, incentivi e misure applicabili",
          "Coordinamento del percorso tecnico, amministrativo e finanziario"
        ]
      },
      "old_lead": {
        "it": "Prima si vende l'impianto, poi si cerca come finanziarlo."
      },
      "old_desc": {
        "it": "Tecnologia, incentivi e sostenibilità finanziaria vengono spesso affrontati in momenti diversi e da interlocutori separati."
      },
      "old_points": {
        "it": [
          "Tecnologia scelta isolatamente",
          "Incentivi valutati dopo",
          "Finanza scollegata dal progetto"
        ]
      }
    },
    {
      "num": "04",
      "title": {
        "it": "Dal green dichiarato al green dimostrabile"
      },
      "new_lead": {
        "it": "La sostenibilità deve essere misurabile e dimostrabile."
      },
      "new_points": {
        "it": [
          "Garanzie d'Origine e provenienza dell'energia",
          "Granularità e tracciabilità dei dati",
          "Supporto a ESG, audit e certificazioni",
          "Dialogo con supplier e piattaforme per recuperare solo i dati utili"
        ]
      },
      "old_lead": {
        "it": "Green come attributo commerciale."
      },
      "old_desc": {
        "it": "Si acquista un prodotto «verde», ma dati, fonti, evidenze e requisiti di reporting vengono affrontati solo quando qualcuno li richiede."
      },
      "old_points": {
        "it": [
          "Claim generici",
          "Evidenze frammentate",
          "Richieste dati non coordinate"
        ]
      }
    },
    {
      "num": "05",
      "title": {
        "it": "Dal prodotto alla regia"
      },
      "new_lead": {
        "it": "Una sola regia. Le competenze giuste quando servono."
      },
      "new_points": {
        "it": [
          "Fornitori energia e technical partner",
          "Professionisti per incentivi e certificazioni",
          "Laboratori e specialisti ambientali",
          "Broker assicurativi abilitati per le coperture dedicate",
          "Coordinamento fino all'execution e alla gestione continuativa"
        ]
      },
      "old_lead": {
        "it": "Ogni problema genera un nuovo fornitore."
      },
      "old_desc": {
        "it": "Energia, impianti, incentivi, certificazioni, assicurazioni e servizi specialistici vengono gestiti separatamente. Il cliente resta l'unico soggetto costretto a coordinare tutti."
      },
      "old_points": {
        "it": [
          "Molti interlocutori",
          "Responsabilità frammentate",
          "Nessuna regia complessiva"
        ]
      }
    }
  ],
  "metodo": [
    {
      "num": "1",
      "tab": {
        "it": "Analisi & Profilazione"
      },
      "title": {
        "it": "Analisi & Profilazione"
      },
      "lead": {
        "it": "Partiamo dalla fotografia reale del cliente."
      },
      "desc": {
        "it": "Raccogliamo dati energetici, bollette, contratti, curve di consumo, impianti e informazioni operative e finanziarie utili a comprendere il profilo complessivo."
      },
      "points": {
        "it": [
          "Consumi, costi e contratti",
          "Profilo commerciale, credit check e modalità di pagamento",
          "Impianti, processi e caratteristiche operative",
          "Criticità, scadenze e priorità"
        ]
      }
    },
    {
      "num": "2",
      "tab": {
        "it": "Strategia & Ottimizzazione"
      },
      "title": {
        "it": "Strategia & Ottimizzazione"
      },
      "lead": {
        "it": "Definiamo dove comprare meglio, consumare meno e produrre in modo più efficiente."
      },
      "desc": {
        "it": "Dalla fotografia iniziale costruiamo una strategia che integra approvvigionamento, rischio, efficienza, produzione energetica, incentivi ed esigenze ESG."
      },
      "points": {
        "it": [
          "Strategia di acquisto e struttura prezzo",
          "Ottimizzazione di consumi e impianti",
          "Autoconsumo e produzione energetica",
          "Incentivi e sostenibilità economica degli interventi"
        ]
      }
    },
    {
      "num": "3",
      "tab": {
        "it": "Soluzioni & Partner"
      },
      "title": {
        "it": "Selezione delle Soluzioni & dei Partner"
      },
      "lead": {
        "it": "Per ogni esigenza, la soluzione e il partner più adatti."
      },
      "desc": {
        "it": "Ethic confronta fornitori, tecnologie e competenze specialistiche sulla base del profilo reale del cliente, evitando soluzioni standard."
      },
      "points": {
        "it": [
          "Supplier fit e confronto offerte",
          "Selezione dei partner tecnici",
          "Tecnologie e interventi",
          "Professionisti specialistici",
          "Broker assicurativi abilitati, quando necessari"
        ]
      }
    },
    {
      "num": "4",
      "tab": {
        "it": "Execution & Coordinamento"
      },
      "title": {
        "it": "Execution & Coordinamento"
      },
      "lead": {
        "it": "Trasformiamo la strategia in attività concrete."
      },
      "desc": {
        "it": "Ethic mantiene la regia tra cliente, fornitori, tecnici e professionisti fino alla messa a terra della soluzione."
      },
      "points": {
        "it": [
          "Attivazioni e pratiche",
          "Implementazione degli interventi",
          "Coordinamento fornitori e tecnici",
          "Incentivi, certificazioni e adempimenti",
          "Gestione delle tempistiche"
        ]
      }
    },
    {
      "num": "5",
      "tab": {
        "it": "Gestione & Evoluzione"
      },
      "title": {
        "it": "Gestione, Controllo & Evoluzione"
      },
      "lead": {
        "it": "Il lavoro continua dopo l'attivazione."
      },
      "desc": {
        "it": "Monitoriamo forniture, consumi, condizioni contrattuali, performance e nuove esigenze, aggiornando nel tempo la strategia."
      },
      "points": {
        "it": [
          "Controllo bollette, costi e consumi",
          "Rinnovi e rinegoziazioni",
          "Nuove utenze e variazioni operative",
          "Monitoraggio delle performance",
          "ESG, tracciabilità e certificazioni",
          "Nuove opportunità di efficienza, incentivi e protezione del rischio"
        ]
      }
    }
  ],
  "manifesto_visual": {
    "old_items": {
      "it": [
        "Fornitura → offerta / contratto",
        "Impianto → tecnico / preventivo",
        "Incentivo → consulente / pratica",
        "ESG → richieste dati separate ai fornitori",
        "Rischio → broker / polizza"
      ]
    },
    "old_msg": {
      "it": "Prodotti e professionisti separati. Il coordinamento resta al cliente."
    },
    "new_center": {
      "it": "Profilo del cliente"
    },
    "new_items": {
      "it": [
        "Acquisto energia",
        "Consumi & efficienza",
        "Produzione & tecnologie",
        "Investimenti & incentivi",
        "ESG & certificazioni",
        "Rischio & servizi specialistici"
      ]
    },
    "new_regia_label": {
      "it": "Regia Ethic"
    },
    "new_flow": {
      "it": [
        "Analisi",
        "Strategia",
        "Selezione",
        "Execution",
        "Gestione"
      ]
    }
  },
  "servizi": [
    {
      "id": "energy-management",
      "num": "01",
      "title": {
        "it": "Gestione Energia & Approvvigionamento"
      },
      "desc": {
        "it": "Gestire forniture, contratti e mercato con una strategia costruita sul profilo reale del cliente."
      },
      "items": {
        "it": [
          "Analisi & profilazione",
          "Forniture & gare",
          "Strategie FIX / FLEX / MIX",
          "Trading & PPA",
          "Energia rinnovabile & tracciabilità",
          "Gestione continuativa"
        ]
      }
    },
    {
      "id": "efficiency-transition",
      "num": "02",
      "title": {
        "it": "Efficienza & Transizione Energetica"
      },
      "desc": {
        "it": "Ridurre i consumi, migliorare gli impianti e integrare tecnologie, produzione e incentivi in un unico percorso."
      },
      "items": {
        "it": [
          "Diagnosi & progetti integrati",
          "Fotovoltaico, batterie, CER & colonnine",
          "Pompe di calore & impianti termici",
          "Involucro & serramenti",
          "Incentivi & pratiche GSE",
          "Efficienza dei combustibili & soluzioni chimiche"
        ]
      }
    },
    {
      "id": "technical-risk",
      "num": "03",
      "title": {
        "it": "Soluzioni Tecniche, Ambientali & Gestione del Rischio"
      },
      "desc": {
        "it": "Attivare competenze specialistiche tecniche, ambientali, assicurative e amministrative, mantenendo un unico presidio verso il cliente."
      },
      "items": {
        "it": [
          "Coordinamento di progetto",
          "Energy Manager & specialisti",
          "Soluzioni assicurative",
          "LEED & certificazioni",
          "Servizi ambientali",
          "Acque, Legionella & fiscalità energetica"
        ]
      }
    }
  ],
  "target": [
    {
      "id": "sgr",
      "label": {
        "it": "SGR, Fondi & Grandi Patrimoni Immobiliari"
      },
      "headline": {
        "it": "Portafogli immobiliari sotto controllo energetico"
      },
      "payoff": {
        "it": "Energy governance, performance ed ESG per patrimoni multi-asset."
      },
      "intro": {
        "it": "Ethic affianca SGR, fondi e grandi patrimoni immobiliari nella gestione integrata di energia, impianti, performance ESG e servizi specialistici. Lavoriamo al fianco di CFO, Property/Asset Manager, ESG Manager ed Energy Manager, entrando in profondità nei dati, nei contratti e nelle logiche commerciali dei fornitori. Centralizziamo dati e processi, profiliamo ogni asset e selezioniamo per ogni esigenza il supplier o il technical partner più adatto. Dalla procurement strategy all'execution, fino alla gestione continuativa: un'unica regia per aumentare controllo, prevedibilità e qualità del reporting."
      },
      "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "seo_title": {
        "it": "Gestione energia per SGR e fondi immobiliari | ETHIC ENERGY",
        "en": "Energy management for real estate funds | ETHIC ENERGY"
      },
      "seo_desc": {
        "it": "Gestione centralizzata delle forniture di portafogli immobiliari: gare multi-asset, PPA, controllo bollette e regia operativa tra SGR, property e fornitori.",
        "en": "Centralised supply management for real estate portfolios: multi-asset tenders, PPAs, bill control and operational coordination between asset managers and suppliers."
      },
      "pagina": {
        "cta_primary": {
          "it": "Richiedi un'analisi del portafoglio"
        },
        "cta_secondary": {
          "it": "Parla con un advisor"
        },
        "blocks": [
          {
            "tipo": "blocco",
            "num": "01",
            "title": {
              "it": "Energy Procurement & Portfolio Management"
            },
            "sub": {
              "it": "Controllo centralizzato, decisioni asset-specific."
            },
            "desc": {
              "it": "Ethic costruisce una governance energetica di portafoglio mantenendo la granularità necessaria sul singolo asset. Consumi, contratti, credit check, affidabilità, condizioni e tempi di pagamento, garanzie, volumi e caratteristiche operative concorrono alla profilazione e alla selezione del supplier più coerente. La lettura è insieme tecnica e finanziaria: il prezzo conta, ma deve essere compatibile con il profilo reale dell'asset e del veicolo, anche in presenza di esigenze multi-vettore."
            },
            "points": {
              "it": [
                "Portfolio assessment, controllo bollette e gestione multi-POD/PDR",
                "Profilazione commerciale, credit check e supplier fit per asset / veicolo",
                "Multi-energy procurement: energia elettrica, gas, GPL e gasolio per asset con esigenze e vettori energetici differenti",
                "Gare, benchmark e strategie FIX / FLEX / MIX",
                "PPA, green supply, Garanzie d'Origine e tracciabilità",
                "Rinnovi, rinegoziazioni, attivazioni e gestione continuativa"
              ]
            },
            "note": {
              "it": "Il supplier giusto non è necessariamente lo stesso per tutto il portafoglio."
            }
          },
          {
            "tipo": "blocco",
            "num": "02",
            "title": {
              "it": "Portfolio Control, Forecasting & Reporting"
            },
            "sub": {
              "it": "Dati confrontabili. Forecast più affidabili. Decisioni più rapide."
            },
            "desc": {
              "it": "Ethic organizza e normalizza i dati energetici del portafoglio per renderli utilizzabili nelle attività di controllo, budgeting, forecast, reporting e governance, integrando informazioni economiche, contrattuali e operative."
            },
            "points": {
              "it": [
                {
                  "t": "Consolidamento dati e benchmark tra asset",
                  "d": "Raccolta e normalizzazione dei dati energetici per confrontare consumi, costi e performance tra immobili e perimetri diversi."
                },
                {
                  "t": "Budget, forecast e analisi degli scostamenti",
                  "d": "Analisi di costi e consumi, costruzione dei forecast e lettura degli scostamenti tra budget, previsioni e dati actual."
                },
                {
                  "t": "Contratti, scadenze e criticità operative",
                  "d": "Monitoraggio di rinnovi, condizioni contrattuali, pagamenti, scaduti e stato degli interventi per mantenere sotto controllo il perimetro operativo."
                },
                {
                  "t": "KPI energetici e performance degli asset",
                  "d": "Monitoraggio di consumi, costi, emissioni e principali indicatori energetici per asset e a livello di portafoglio."
                },
                {
                  "t": "Dati energetici per ESG, governance e reporting",
                  "d": "Predisposizione di dati e indicatori utilizzabili nei reporting interni, nei comitati e nella rendicontazione verso investitori e stakeholder."
                }
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "03",
            "title": {
              "it": "Energy Efficiency & Asset Performance"
            },
            "sub": {
              "it": "Dal controllo dei consumi alla valorizzazione dell'asset."
            },
            "desc": {
              "it": "Gli interventi vengono valutati in funzione di CAPEX, OPEX, payback, tenant profile, incentivi e obiettivi ESG, selezionando per ogni tecnologia il technical partner più adatto."
            },
            "points": {
              "it": [
                "Diagnosi energetiche e piani di efficientamento per asset",
                "Fotovoltaico, storage, CER e infrastrutture di ricarica",
                "Pompe di calore, centrali termiche e ottimizzazione impianti",
                "Involucro, serramenti e riqualificazione energetica",
                "Conto Termico, incentivi e pratiche GSE"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "04",
            "title": {
              "it": "ESG, Certifications & Green Performance"
            },
            "sub": {
              "it": "Performance energetica che diventa asset value."
            },
            "desc": {
              "it": "Ethic collega procurement, tracciabilità dell'energia, dati e certificazioni per costruire evidenze verificabili a supporto di ESG e asset performance. Dialoghiamo direttamente con i fornitori, sappiamo quali dati richiedere, dove reperirli e come strutturare le richieste in modo efficace per ridurre tempi, duplicazioni e informazioni non utili."
            },
            "points": {
              "it": [
                "Green supply, PPA e Garanzie d'Origine",
                "Piattaforme di tracciabilità e granularità della provenienza dell'energia per esigenze ESG e certificazioni",
                "Supporto LEED, WELL, BREEAM e altri protocolli",
                "Raccolta e organizzazione delle evidenze per audit e certificazioni",
                "Supporto a reporting ESG e strategie di decarbonizzazione"
              ]
            },
            "note": {
              "it": "Non basta acquistare energia green. Ethic entra nel dato insieme ai fornitori, individua le evidenze realmente utili, ne ottimizza la raccolta e supporta ESG Manager ed Energy Manager nel dimostrare provenienza, granularità e coerenza con i requisiti di reporting e certificazione."
            },
            "highlight": true
          },
          {
            "tipo": "blocco",
            "num": "05",
            "title": {
              "it": "Technical & Environmental Services"
            },
            "sub": {
              "it": "Un'unica regia anche per le esigenze specialistiche degli asset."
            },
            "desc": {
              "it": "Ethic coordina specialisti, property, facility e fornitori per ridurre frammentazione e mantenere un unico presidio operativo."
            },
            "points": {
              "it": [
                "Analisi acque, Legionella e servizi ambientali",
                "Bonifica serbatoi e servizi per cantieri",
                "Manutenzione, conduzione e specialist advisory",
                "Supporto tecnico a certificazioni e compliance",
                "Coordinamento di professionisti e operatori specialistici"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "06",
            "title": {
              "it": "Risk Management & Insurance Solutions"
            },
            "sub": {
              "it": "Proteggere performance, impianti e continuità operativa."
            },
            "desc": {
              "it": "Ethic integra la lettura tecnica ed energetica dell'asset con broker assicurativi specializzati, senza sostituirsi all'intermediazione assicurativa."
            },
            "points": {
              "it": [
                "Soluzioni parametriche legate a consumi, temperatura o altre variabili energetiche",
                "Coperture per fotovoltaico e impianti energetici",
                "Coperture per centrali termiche",
                "Coperture legate a interventi e manutenzioni"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "07",
            "title": {
              "it": "Execution, Coordination & Manager Support"
            },
            "sub": {
              "it": "La strategia crea valore solo quando viene eseguita."
            },
            "desc": {
              "it": "Ethic lavora al fianco di ESG Manager, Energy Manager, CFO, asset manager e property manager senza sostituirne la governance. Portiamo una lettura tecnica e finanziaria del portafoglio, approfondiamo dati e condizioni dei fornitori e coordiniamo procurement, specialisti ed execution per trasformare obiettivi interni in decisioni operative più solide."
            },
            "points": {
              "it": [
                "Governance e supporto a ESG / Energy Manager",
                "Supplier intelligence, credit check e technical partner coordination",
                "Execution di attivazioni, lavori e pratiche",
                "Standard comuni con gestione asset-specific",
                "Continuous management su rinnovi, pagamenti, modifiche e nuove esigenze"
              ]
            },
            "highlight": true
          },
          {
            "tipo": "personas",
            "heading": {
              "it": "Una sola regia, esigenze diverse"
            },
            "personas": [
              {
                "title": {
                  "it": "CFO / Amministrazione"
                },
                "text": {
                  "it": "Costi, budget, forecast, credit check, condizioni di pagamento, scaduti e rischio contrattuale."
                }
              },
              {
                "title": {
                  "it": "Property / Asset Manager"
                },
                "text": {
                  "it": "Performance, fornitori, interventi, coordinamento ed execution."
                }
              },
              {
                "title": {
                  "it": "ESG Manager"
                },
                "text": {
                  "it": "Tracciabilità, dati dai fornitori, certificazioni, evidenze e decarbonizzazione."
                }
              },
              {
                "title": {
                  "it": "Facility Manager"
                },
                "text": {
                  "it": "Impianti, manutenzione, continuità operativa e criticità."
                }
              },
              {
                "title": {
                  "it": "Energy Manager"
                },
                "text": {
                  "it": "Analisi tecnica, procurement support, dati, supplier intelligence e implementazione delle scelte."
                }
              }
            ]
          },
          {
            "tipo": "cta_finale",
            "heading": {
              "it": "Governare l'energia di portafoglio, non rincorrerla."
            },
            "text": {
              "it": "Partiamo da dati, asset, contratti e processi esistenti. Costruiamo una lettura tecnica e finanziaria del portafoglio, individuiamo priorità e opportunità e definiamo un modello di gestione coerente con obiettivi economici, operativi ed ESG, lavorando al fianco dei manager interni."
            }
          }
        ]
      }
    },
    {
      "id": "industrie",
      "label": {
        "it": "Industrie"
      },
      "headline": {
        "it": "Energia, procurement ed efficienza per l'industria"
      },
      "payoff": {
        "it": "Strategia, mercato ed execution al fianco dell'Energy Manager."
      },
      "intro": {
        "it": "Ethic affianca imprese industriali, Energy Manager e direzioni aziendali nella gestione dell'energia lungo tutto il ciclo: analisi dei consumi, procurement, costruzione del prezzo, tracciabilità, efficienza, incentivi e servizi specialistici.\n\nPortiamo accesso a fornitori e trading desk dedicati, competenze tecniche e una lettura insieme energetica e finanziaria del cliente, costruendo strategie coerenti con profilo di consumo, rischio, condizioni di pagamento e obiettivi ESG."
      },
      "image": "https://images.unsplash.com/photo-1649294012573-c31585a390b9?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "seo_title": {
        "it": "Consulenza energetica per industrie | ETHIC ENERGY",
        "en": "Energy consulting for industries | ETHIC ENERGY"
      },
      "seo_desc": {
        "it": "Procurement energetico industriale: strategie Fix/Flex/Mix, trading desk, PPA, diagnosi energetiche, fotovoltaico e gestione continuativa delle forniture.",
        "en": "Industrial energy procurement: Fix/Flex/Mix strategies, trading desk, PPAs, energy audits, solar PV and ongoing supply management."
      },
      "pagina": {
        "cta_primary": {
          "it": "Richiedi un'analisi energetica"
        },
        "cta_secondary": {
          "it": "Parla con Ethic"
        },
        "blocks": [
          {
            "tipo": "blocco",
            "num": "01",
            "title": {
              "it": "Energy Procurement & Trading"
            },
            "sub": {
              "it": "Dal consumo al prezzo: una strategia costruita sul profilo reale dell'azienda."
            },
            "desc": {
              "it": "Ethic analizza curve di carico, volumi, stagionalità, budget, profilo di rischio, credit check e condizioni di pagamento per costruire la strategia di approvvigionamento più coerente e selezionare il supplier più adatto."
            },
            "points": {
              "it": [
                "Strategie FIX / FLEX / MIX",
                "Accesso a trading desk, fixing e costruzione del prezzo",
                "Gare, benchmark e negoziazione",
                "PPA e contratti strutturati",
                "Gestione continuativa di forniture, rinnovi e rinegoziazioni"
              ]
            },
            "note": {
              "it": "Non scegliamo solo un prezzo. Costruiamo il modello di acquisto."
            }
          },
          {
            "tipo": "blocco",
            "num": "02",
            "title": {
              "it": "Energy Strategy, Monitoring & Control"
            },
            "sub": {
              "it": "Dati, consumi e costi sotto controllo."
            },
            "desc": {
              "it": "Ethic affianca l'Energy Manager nella lettura dei consumi e delle performance energetiche, trasformando dati tecnici e contrattuali in indicazioni utilizzabili per procurement, budget e decisioni operative."
            },
            "points": {
              "it": [
                "Analisi curve di carico e profili di consumo",
                "Monitoraggio costi e performance energetiche",
                "Controllo bollette, anomalie e condizioni contrattuali",
                "Supporto a budget, forecast e analisi degli scostamenti"
              ]
            }
          },
          {
            "tipo": "personas",
            "heading": {
              "it": "Al fianco dell'Energy Manager"
            },
            "sub": {
              "it": "Più profondità di mercato, senza sostituirsi alla governance interna."
            },
            "desc": {
              "it": "Ethic lavora al fianco dell'Energy Manager e delle funzioni tecniche, finanziarie ed ESG portando accesso al mercato, supplier intelligence, trading, specialisti verticali e capacità di execution. L'Energy Manager mantiene la governance interna; Ethic amplia la capacità di analisi, confronto e implementazione."
            },
            "personas": [
              {
                "title": {
                  "it": "Energy Manager"
                },
                "text": {
                  "it": "Consumi, strategie di acquisto, impianti, performance ed execution."
                }
              },
              {
                "title": {
                  "it": "CFO / Procurement"
                },
                "text": {
                  "it": "Prezzo, budget, rischio, credit check, condizioni contrattuali e finanziarie."
                }
              },
              {
                "title": {
                  "it": "ESG Manager"
                },
                "text": {
                  "it": "Tracciabilità, provenienza dell'energia, emissioni, certificazioni ed evidenze."
                }
              }
            ]
          },
          {
            "tipo": "blocco",
            "num": "03",
            "title": {
              "it": "Green Procurement, Traceability & ESG"
            },
            "sub": {
              "it": "Energia rinnovabile, ma con evidenze verificabili."
            },
            "desc": {
              "it": "Ethic costruisce strategie di approvvigionamento rinnovabile coerenti con gli obiettivi ESG e supporta l'azienda nella raccolta delle evidenze necessarie. Dialoghiamo con supplier e piattaforme specialistiche per recuperare, organizzare e ottimizzare i dati utili alla tracciabilità dell'energia."
            },
            "points": {
              "it": [
                "Green supply e Garanzie d'Origine",
                "PPA",
                "Piattaforme di tracciabilità e granularità della provenienza dell'energia",
                "Dati energetici per ESG, audit e certificazioni",
                "Supporto alla decarbonizzazione del procurement"
              ]
            },
            "note": {
              "it": "Non basta acquistare energia green: bisogna sapere da dove arriva e poterlo dimostrare."
            }
          },
          {
            "tipo": "blocco",
            "num": "04",
            "title": {
              "it": "Efficienza & Asset Energetici"
            },
            "sub": {
              "it": "Ridurre OPEX e consumi, migliorando gli impianti."
            },
            "desc": {
              "it": "Ethic parte dall'analisi tecnica ed economica dell'intervento e seleziona, per ogni tecnologia, il technical partner più adatto alla dimensione e alla complessità del sito."
            },
            "points": {
              "it": [
                "Diagnosi e piani di efficientamento",
                "Grandi impianti fotovoltaici e storage",
                "Pompe di calore, HVAC e riqualificazione degli impianti",
                "Involucro, serramenti e riduzione delle dispersioni",
                "Ottimizzazione e manutenzione dei sistemi energetici"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "05",
            "title": {
              "it": "CER, Autoconsumo & Nuovi Modelli Energetici"
            },
            "sub": {
              "it": "Produrre, condividere e valorizzare l'energia."
            },
            "desc": {
              "it": "Ethic valuta autoconsumo, configurazioni CER, integrazione con fotovoltaico e storage e possibili modelli di condivisione dell'energia, selezionando i partner tecnici e amministrativi più adatti."
            },
            "points": {
              "it": [
                "CER e configurazioni di autoconsumo",
                "Sviluppo o partecipazione a Comunità Energetiche",
                "Integrazione fotovoltaico + storage",
                "Valutazione economica dei flussi energetici"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "06",
            "title": {
              "it": "Incentivi & Investment Support"
            },
            "sub": {
              "it": "Rendere più sostenibile anche il CAPEX."
            },
            "desc": {
              "it": "Ethic verifica gli strumenti agevolativi applicabili e coordina il percorso tecnico, amministrativo e finanziario collegato agli investimenti energetici."
            },
            "points": {
              "it": [
                "Iperammortamento e misure fiscali applicabili",
                "Conto Termico",
                "Pratiche GSE",
                "Incentivi nazionali e locali",
                "Coordinamento tecnico-amministrativo dell'intervento"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "07",
            "title": {
              "it": "Combustibili, Processi & Soluzioni Specialistiche"
            },
            "sub": {
              "it": "Non solo energia elettrica e gas."
            },
            "desc": {
              "it": "Ethic interviene anche sui vettori energetici e sui processi che richiedono competenze specialistiche, selezionando fornitori e professionisti dedicati."
            },
            "points": {
              "it": [
                "Fornitura gasolio, GPL e combustibili tecnici",
                "Additivi e chimica per l'efficienza dei combustibili",
                "Verifica accise e agevolazioni fiscali sui carburanti",
                "Supporto specialistico su consumi e processi termici"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "08",
            "title": {
              "it": "Bonifiche & Servizi Ambientali Industriali"
            },
            "sub": {
              "it": "Interventi specialistici su siti e impianti complessi."
            },
            "desc": {
              "it": "Ethic coordina operatori qualificati per attività ambientali e di bonifica legate a impianti, serbatoi, cantieri e siti produttivi."
            },
            "points": {
              "it": [
                "Bonifica e messa in sicurezza serbatoi",
                "Bonifiche industriali e di cantiere",
                "Servizi ambientali specialistici",
                "Coordinamento di operatori qualificati"
              ]
            }
          },
          {
            "tipo": "cta_finale",
            "heading": {
              "it": "Costruiamo la strategia energetica intorno al tuo processo produttivo."
            },
            "text": {
              "it": "Partiamo da consumi, contratti, impianti e obiettivi. Individuiamo le priorità e costruiamo un percorso coerente tra procurement, efficienza, rischio ed ESG."
            }
          }
        ]
      }
    },
    {
      "id": "condomini",
      "label": {
        "it": "Condomìni"
      },
      "headline": {
        "it": "Il condominio, sotto controllo."
      },
      "payoff": {
        "it": "Forniture, impianti, lavori, incentivi e servizi coordinati da un unico interlocutore."
      },
      "intro": {
        "it": "Ethic affianca amministratori e condominii nella gestione delle forniture energetiche, degli impianti e dei servizi tecnici. Partiamo dal profilo reale del condominio, individuiamo le priorità, selezioniamo fornitori e partner adatti alle sue caratteristiche e coordiniamo le soluzioni fino all'implementazione e alla gestione continuativa."
      },
      "image": "https://images.unsplash.com/photo-1775045309223-df2cd3ef3a0f?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "seo_title": {
        "it": "Gestione energia per condomìni | ETHIC ENERGY",
        "en": "Energy management for condominiums | ETHIC ENERGY"
      },
      "seo_desc": {
        "it": "Forniture luce e gas, fotovoltaico, CER, Conto Termico e pratiche GSE per condomìni: un unico interlocutore dalla bolletta all'intervento.",
        "en": "Electricity and gas supplies, solar PV, CER, Conto Termico and GSE procedures for condominiums: one point of contact from bill to works."
      },
      "pagina": {
        "cta_primary": {
          "it": "Richiedi un check del condominio"
        },
        "blocks": [
          {
            "tipo": "blocco",
            "num": "01",
            "title": {
              "it": "Spese, bollette & forniture"
            },
            "sub": {
              "it": "Il fornitore giusto dipende anche dal condominio."
            },
            "desc": {
              "it": "Ethic non confronta soltanto il prezzo. Analizziamo consumi, caratteristiche della fornitura, affidabilità, modalità e tempi di pagamento per individuare operatori e condizioni realmente compatibili con il profilo del condominio."
            },
            "points": {
              "it": [
                "Controllo bollette e anomalie",
                "Selezione del fornitore di luce, gas o gasolio in base al profilo del condominio",
                "Valutazione di condizioni, modalità e tempi di pagamento",
                "Rinnovi e rinegoziazioni",
                "Gestione continuativa delle forniture POD e PDR"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "02",
            "title": {
              "it": "Impianti & manutenzione"
            },
            "sub": {
              "it": "Efficienza e continuità degli impianti nel tempo."
            },
            "desc": {
              "it": "Ethic analizza il fabbisogno del condominio e seleziona il partner tecnico più adatto in funzione dell'impianto, della dimensione del condominio e dell'intervento richiesto."
            },
            "points": {
              "it": [
                "Manutenzione e ottimizzazione delle centrali termiche",
                "Riqualificazione delle centrali termiche",
                "Pompe di calore",
                "Coordinamento di tecnici, manutentori e installatori"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "03",
            "title": {
              "it": "Energia, autoconsumo & mobilità"
            },
            "sub": {
              "it": "Produrre energia e utilizzarla meglio."
            },
            "desc": {
              "it": "Ethic valuta il fabbisogno del condominio e seleziona per ogni intervento il partner tecnico più adatto."
            },
            "points": {
              "it": [
                "Fotovoltaico condominiale",
                "Batterie e sistemi di accumulo",
                "Comunità Energetiche Rinnovabili (CER)",
                "Colonnine condominiali o per singoli condomini",
                "Integrazione tra fotovoltaico, accumulo, ricarica e fornitura"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "04",
            "title": {
              "it": "Incentivi per la riqualificazione degli impianti"
            },
            "sub": {
              "it": "Sfruttare gli strumenti disponibili per rendere più sostenibili gli interventi sugli impianti."
            },
            "desc": {
              "it": "Ethic parte dall'intervento da realizzare, verifica gli strumenti agevolativi applicabili e coordina il percorso con i professionisti e i partner necessari, integrando aspetti tecnici, amministrativi e finanziari."
            },
            "points": {
              "it": [
                "Incentivi locali",
                "Conto Termico",
                "Pratiche GSE",
                "Coordinamento del percorso tecnico, amministrativo e finanziario"
              ]
            }
          },
          {
            "tipo": "blocco_sub",
            "num": "05",
            "title": {
              "it": "Ambiente & servizi tecnici"
            },
            "sub": {
              "it": "Servizi specialistici per edificio, impianti e aree comuni."
            },
            "subblocks": [
              {
                "title": {
                  "it": "Bonifiche cantieri & serbatoi"
                },
                "points": {
                  "it": [
                    "Bonifica, pulizia e messa in sicurezza dei serbatoi",
                    "Servizi ambientali collegati a lavori e cantieri",
                    "Coordinamento di operatori specializzati"
                  ]
                }
              },
              {
                "title": {
                  "it": "Autospurgo & fosse biologiche"
                },
                "points": {
                  "it": [
                    "Autospurgo",
                    "Pulizia fosse biologiche",
                    "Interventi periodici e programmati"
                  ]
                }
              },
              {
                "title": {
                  "it": "Analisi acque & Legionella"
                },
                "points": {
                  "it": [
                    "Analisi e monitoraggio delle acque",
                    "Prevenzione e controllo del rischio Legionella e relative assicurazioni",
                    "Laboratori e professionisti qualificati"
                  ]
                }
              }
            ]
          },
          {
            "tipo": "blocco",
            "num": "06",
            "title": {
              "it": "Protezione di impianti e rischi energetici"
            },
            "sub": {
              "it": "Soluzioni assicurative dedicate all'energia."
            },
            "desc": {
              "it": "Ethic collabora con broker assicurativi specializzati per valutare coperture legate esclusivamente agli impianti, agli interventi e ai rischi energetici del condominio. Non si tratta di sostituire il broker assicurativo generale del condominio."
            },
            "points": {
              "it": [
                "Soluzioni parametriche legate a consumi, temperatura o altre variabili energetiche, dove applicabili",
                "Coperture per impianti fotovoltaici e centrali termiche",
                "Coperture legate a interventi e manutenzioni"
              ]
            }
          },
          {
            "tipo": "steps",
            "heading": {
              "it": "Un supporto concreto all'amministratore"
            },
            "sub": {
              "it": "Un unico punto di coordinamento, dalla necessità alla gestione."
            },
            "steps": [
              {
                "title": {
                  "it": "Analisi e profilazione"
                },
                "text": {
                  "it": "Partiamo da bollette, contratti, impianti e caratteristiche del condominio. Per le forniture consideriamo anche modalità e tempi di pagamento, affidabilità e compatibilità con i diversi operatori."
                }
              },
              {
                "title": {
                  "it": "Selezione della soluzione"
                },
                "text": {
                  "it": "Confrontiamo fornitori, tecnologie e partner in funzione delle reali esigenze del condominio."
                }
              },
              {
                "title": {
                  "it": "Proposta strutturata"
                },
                "text": {
                  "it": "Organizziamo soluzioni, costi, alternative e documentazione in modo chiaro, facilitando il percorso decisionale dell'amministratore e del condominio."
                }
              },
              {
                "title": {
                  "it": "Coordinamento operativo"
                },
                "text": {
                  "it": "Mettiamo in relazione amministratore, tecnici, fornitori, installatori e professionisti fino alla realizzazione."
                }
              },
              {
                "title": {
                  "it": "Gestione continuativa"
                },
                "text": {
                  "it": "Restiamo presenti per forniture, rinnovi, manutenzioni, modifiche e nuove esigenze."
                }
              }
            ]
          },
          {
            "tipo": "special",
            "badge": {
              "it": "CONDEA"
            },
            "heading": {
              "it": "Pagamenti condominiali"
            },
            "sub": {
              "it": "Pagamenti semplici, rendicontati e senza contante."
            },
            "text": {
              "it": "Dall'esperienza dei founder di Ethic nella gestione dei servizi per condominii nasce l'esigenza di rendere più semplice anche un altro aspetto della vita condominiale: i pagamenti.\n\nDa questa esigenza è stata sviluppata, insieme a specialisti dei pagamenti elettronici, CONDEA: una soluzione dedicata a incassi e pagamenti condominiali, pensata per semplificare la gestione, migliorare la rendicontazione e ridurre fino a eliminare l'utilizzo del contante."
            },
            "points": {
              "it": [
                "Incassi e pagamenti",
                "Rendicontazione e riconciliazione",
                "Controllo degli scaduti",
                "Tracciabilità dei flussi",
                "Riduzione ed eliminazione del contante"
              ]
            }
          },
          {
            "tipo": "cta_finale",
            "heading": {
              "it": "Partiamo dal tuo condominio."
            },
            "text": {
              "it": "Una bolletta da controllare, una centrale termica da riqualificare, un servizio da organizzare o un nuovo progetto da valutare: raccontaci l'esigenza e costruiamo il percorso più adatto."
            }
          }
        ]
      }
    },
    {
      "id": "pmi",
      "label": {
        "it": "PMI"
      },
      "headline": {
        "it": "Il fornitore giusto per il profilo reale dell'impresa"
      },
      "payoff": {
        "it": "Prezzo, contratti e gestione energetica senza complicazioni."
      },
      "intro": {
        "it": "Ethic affianca PMI, studi, uffici, negozi, ristoranti e piccole attività produttive nella gestione dell'energia. Partiamo da bollette, consumi, contratti e modalità di pagamento per individuare il fornitore e la strategia più coerenti, evitando rinnovi poco convenienti e condizioni non adatte al profilo dell'impresa.\n\nDopo l'attivazione, il supporto continua: scadenze, variazioni di potenza, nuovi POD/PDR, incentivi e interventi di efficienza vengono gestiti con un unico presidio."
      },
      "image": "https://images.unsplash.com/photo-1497366216548-37526070297c?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "seo_title": {
        "it": "Consulenza energia per PMI | ETHIC ENERGY",
        "en": "Energy consulting for SMEs | ETHIC ENERGY"
      },
      "seo_desc": {
        "it": "Analisi bollette, confronto tra fornitori realmente compatibili, attivazioni e gestione continuativa delle forniture luce e gas per le PMI.",
        "en": "Bill analysis, comparison of truly compatible suppliers, activations and ongoing management of electricity and gas supplies for SMEs."
      },
      "pagina": {
        "cta_primary": {
          "it": "Invia una bolletta"
        },
        "cta_secondary": {
          "it": "Richiedi un check energetico"
        },
        "blocks": [
          {
            "tipo": "cards",
            "heading": {
              "it": "Un unico interlocutore per esigenze diverse"
            },
            "sub": {
              "it": "Meno fornitori da coordinare, più controllo."
            },
            "desc": {
              "it": "Ethic coordina fornitori e partner specialistici in funzione dell'esigenza, mantenendo un unico punto di contatto verso l'impresa."
            },
            "cards": [
              {
                "icon": "zap",
                "title": {
                  "it": "Energia"
                },
                "text": {
                  "it": "Bollette, contratti, prezzi, rinnovi e selezione del fornitore più adatto."
                }
              },
              {
                "icon": "settings",
                "title": {
                  "it": "Gestione"
                },
                "text": {
                  "it": "POD/PDR, potenze, attivazioni, scadenze e supporto operativo."
                }
              },
              {
                "icon": "leaf",
                "title": {
                  "it": "Efficienza"
                },
                "text": {
                  "it": "Fotovoltaico, pompe di calore, serramenti, colonnine e incentivi."
                }
              },
              {
                "icon": "fuel",
                "title": {
                  "it": "Servizi specialistici"
                },
                "text": {
                  "it": "Carburanti, AdBlue, additivi, accise e supporti dedicati."
                }
              }
            ]
          },
          {
            "tipo": "blocco",
            "num": "01",
            "title": {
              "it": "Bollette, contratti & fornitore"
            },
            "sub": {
              "it": "Prima si analizza. Poi si sceglie."
            },
            "desc": {
              "it": "Ethic verifica bollette, contratti, consumi e profilo commerciale dell'impresa per confrontare solo le soluzioni realmente compatibili."
            },
            "points": {
              "it": [
                "Controllo bollette e anomalie",
                "Profilazione commerciale e modalità di pagamento",
                "Selezione del fornitore più adatto",
                "Rinnovi e rinegoziazioni",
                "Gestione continuativa delle forniture"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "02",
            "title": {
              "it": "Strategie di prezzo"
            },
            "sub": {
              "it": "Fisso, variabile o misto: la scelta dipende dal profilo."
            },
            "desc": {
              "it": "Anche una PMI può utilizzare una strategia di acquisto strutturata, senza la complessità tipica delle grandi industrie. Ethic valuta consumi, stagionalità, budget e propensione al rischio per proporre la struttura di prezzo più coerente."
            },
            "points": {
              "it": [
                "FIX",
                "FLEX",
                "MIX",
                "Confronto tra scenari",
                "Supporto nelle fasi di rinnovo"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "03",
            "title": {
              "it": "Gestione utenze & operatività"
            },
            "sub": {
              "it": "Le forniture vanno gestite anche dopo la firma."
            },
            "desc": {
              "it": "Ethic mantiene un presidio operativo anche dopo l'attivazione, supportando l'impresa nelle variazioni che normalmente richiedono tempo e coordinamento con i fornitori."
            },
            "points": {
              "it": [
                "Nuove attivazioni",
                "Volture e subentri",
                "Variazioni di potenza",
                "Gestione POD/PDR",
                "Scadenze e rinnovi"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "04",
            "title": {
              "it": "Efficienza & incentivi"
            },
            "sub": {
              "it": "Interventi concreti, valutati caso per caso."
            },
            "desc": {
              "it": "Quando esiste un'opportunità concreta di riduzione dei consumi, Ethic valuta l'intervento, gli eventuali incentivi e seleziona il partner tecnico più adatto."
            },
            "points": {
              "it": [
                "Fotovoltaico e autoconsumo",
                "Pompe di calore e climatizzazione",
                "Serramenti e riduzione delle dispersioni",
                "Colonnine di ricarica",
                "Conto Termico, incentivi e pratiche GSE"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "05",
            "title": {
              "it": "Flotte, autotrasporto & carburanti"
            },
            "sub": {
              "it": "Energia anche su strada."
            },
            "desc": {
              "it": "Per imprese con flotte, autotrasportatori, officine e attività con consumi di carburante, Ethic combina fornitura, controllo dei costi e servizi specialistici."
            },
            "points": {
              "it": [
                "Fornitura carburanti automotive",
                "Gasolio e altri prodotti petroliferi",
                "Urea / AdBlue",
                "Additivi per performance ed efficienza",
                "Verifica accise e agevolazioni applicabili"
              ]
            }
          },
          {
            "tipo": "cta_finale",
            "heading": {
              "it": "Partiamo dalla tua bolletta."
            },
            "text": {
              "it": "Analizziamo consumi, contratto e profilo dell'impresa e individuiamo dove è possibile migliorare prezzo, condizioni e gestione."
            }
          }
        ]
      }
    },
    {
      "id": "hospitality",
      "label": {
        "it": "Hospitality & Grandi Reti Retail"
      },
      "headline": {
        "it": "Multi-site sotto controllo. Energia, impianti ed execution su ogni sede."
      },
      "payoff": {
        "it": "Prezzo, velocità e continuità operativa per hospitality e grandi reti."
      },
      "intro": {
        "it": "Ethic affianca hotel, strutture ricettive, reti di appartamenti e short stay, catene retail, filiali e organizzazioni multi-sito nella gestione di forniture, consumi, impianti e servizi energetici. Centralizziamo il controllo, profiliamo i punti di consumo, selezioniamo i fornitori più adatti e coordiniamo attivazioni, interventi e nuove aperture.\n\nL'obiettivo è ottenere condizioni competitive, ridurre la dispersione operativa e mantenere una gestione coerente tra sedi con profili di consumo anche molto diversi."
      },
      "image": "https://images.unsplash.com/photo-1773994788136-64d0896159e6?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "seo_title": {
        "it": "Gestione energia per hospitality e retail | ETHIC ENERGY",
        "en": "Energy management for hospitality & retail | ETHIC ENERGY"
      },
      "seo_desc": {
        "it": "Gestione centralizzata delle forniture multi-sito per hotel e retail: nuove aperture, subentri, strategie stagionali, fotovoltaico e ricarica.",
        "en": "Centralised multi-site supply management for hotels and retail: new openings, takeovers, seasonal strategies, solar PV and charging."
      },
      "pagina": {
        "cta_primary": {
          "it": "Richiedi un'analisi multi-sito"
        },
        "cta_secondary": {
          "it": "Parla con Ethic"
        },
        "blocks": [
          {
            "tipo": "cards",
            "heading": {
              "it": "Una rete, esigenze diverse. Un'unica regia."
            },
            "sub": {
              "it": "Hospitality e retail possono avere modelli di consumo molto differenti, ma condividono lo stesso bisogno: controllo centralizzato, corretta gestione delle utenze, rapidità operativa e condizioni economiche coerenti."
            },
            "cards": [
              {
                "icon": "hotel",
                "title": {
                  "it": "Hospitality ad alta intensità energetica"
                },
                "text": {
                  "it": "Hotel, resort e strutture con consumi rilevanti: climatizzazione, acqua calda, impianti, efficienza, Legionella, fotovoltaico e ricarica."
                }
              },
              {
                "icon": "building",
                "title": {
                  "it": "Hospitality diffusa / short stay"
                },
                "text": {
                  "it": "Residence, serviced apartments, reti di appartamenti e locazioni brevi: molti POD/PDR, consumi contenuti per unità, turnover delle utenze, controllo centralizzato e standardizzazione."
                }
              },
              {
                "icon": "store",
                "title": {
                  "it": "Retail & filiali"
                },
                "text": {
                  "it": "Catene di negozi, filiali bancarie e reti distribuite: molti siti, consumi frammentati, aperture/chiusure, potenze, forniture, certificazioni e rollout operativo."
                }
              }
            ]
          },
          {
            "tipo": "blocco",
            "num": "01",
            "title": {
              "it": "Forniture & gestione multi-sito"
            },
            "sub": {
              "it": "Prezzi competitivi, contratti coerenti, gestione centralizzata."
            },
            "desc": {
              "it": "Ethic analizza consumi, stagionalità, caratteristiche dei siti, affidabilità, condizioni e tempi di pagamento per individuare il fornitore e la struttura contrattuale più adatti alla rete."
            },
            "points": {
              "it": [
                "Controllo bollette e gestione multi-POD/PDR",
                "Profilazione commerciale e selezione del fornitore",
                "Strategie FIX / FLEX / MIX coerenti con consumi e stagionalità",
                "Gare, benchmark, rinnovi e rinegoziazioni",
                "Gestione continuativa di forniture, potenze e variazioni operative"
              ]
            },
            "note": {
              "it": "Il miglior prezzo nasce anche da una corretta profilazione: numero di sedi, profilo dei consumi, stagionalità, affidabilità, modalità di pagamento e frequenza delle aperture incidono sulla scelta del supplier."
            }
          },
          {
            "tipo": "blocco",
            "num": "02",
            "title": {
              "it": "Aperture, chiusure & execution"
            },
            "sub": {
              "it": "Ogni nuova sede deve partire senza ritardi."
            },
            "desc": {
              "it": "Ethic presidia l'execution tra sede centrale, fornitori, property e facility, riducendo tempi morti e dispersione informativa."
            },
            "points": {
              "it": [
                "Nuovi POD/PDR e attivazioni",
                "Volture, subentri e cessazioni",
                "Variazioni di potenza",
                "Coordinamento con property, facility e fornitori",
                "Gestione di aperture, trasferimenti e chiusure"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "03",
            "title": {
              "it": "Efficienza & impianti"
            },
            "sub": {
              "it": "Ridurre i consumi senza compromettere comfort e operatività."
            },
            "desc": {
              "it": "Per strutture ad alto consumo, Ethic valuta interventi su climatizzazione, acqua calda, involucro, produzione e impianti. Per reti diffuse di appartamenti, residence, retail e filiali, il focus può essere invece su standardizzazione, controllo dei consumi e soluzioni replicabili su più sedi."
            },
            "points": {
              "it": [
                "Fotovoltaico, batterie e autoconsumo",
                "Pompe di calore, centrali termiche e ottimizzazione impianti",
                "Involucro, serramenti e riduzione delle dispersioni",
                "Manutenzione e interventi replicabili multi-sito",
                "Conto Termico, incentivi e pratiche GSE"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "04",
            "title": {
              "it": "Mobilità elettrica & nuovi servizi"
            },
            "sub": {
              "it": "La ricarica come servizio al cliente e opportunità operativa."
            },
            "points": {
              "it": [
                "Colonnine per hotel, parcheggi, punti vendita e sedi",
                "Soluzioni di ricarica per clienti e flotte",
                "Integrazione con fotovoltaico e accumulo",
                "Gestione dei sistemi di ricarica",
                "Valorizzazione e rivendita del servizio di ricarica, dove applicabile"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "05",
            "title": {
              "it": "ESG, certificazioni & tracciabilità"
            },
            "sub": {
              "it": "Dati e certificazioni anche su reti frammentate."
            },
            "desc": {
              "it": "Una rete distribuita deve poter ricostruire informazioni coerenti anche quando siti, contratti e fornitori sono diversi. Ethic supporta la raccolta dei dati utili e dialoga con i supplier per ottenere e ottimizzare le evidenze richieste a fini ESG, audit e certificazioni."
            },
            "points": {
              "it": [
                "Green supply e Garanzie d'Origine",
                "Tracciabilità e provenienza dell'energia",
                "Supporto LEED, WELL e altri protocolli",
                "Dati energetici per reporting ESG",
                "Coordinamento delle richieste informative verso i fornitori"
              ]
            }
          },
          {
            "tipo": "blocco",
            "num": "06",
            "title": {
              "it": "Hospitality Services & Risk"
            },
            "sub": {
              "it": "Servizi specialistici per strutture ricettive e asset operativi."
            },
            "points": {
              "it": [
                "Analisi acque e Legionella",
                "Manutenzione e ottimizzazione impianti",
                "Bonifica serbatoi e servizi ambientali",
                "Soluzioni assicurative su impianti e rischi energetici",
                "Coperture parametriche legate a temperatura o consumi, dove applicabili"
              ]
            }
          },
          {
            "tipo": "blocco",
            "title": {
              "it": "Coordinamento operativo"
            },
            "sub": {
              "it": "Una sola regia tra sede centrale, siti e fornitori."
            },
            "desc": {
              "it": "Ethic lavora al fianco di energy manager, facility, procurement, amministrazione e funzioni ESG, mantenendo un presidio unico tra rete centrale e punti operativi. La gestione non si ferma alla selezione del fornitore: accompagniamo attivazioni, interventi, rinnovi e nuove esigenze nel tempo."
            },
            "points": {
              "it": [
                "Un unico punto di coordinamento",
                "Supplier e technical partner selezionati in funzione del profilo",
                "Execution rapida sulle sedi",
                "Standard comuni, con gestione delle specificità locali",
                "Supporto continuativo a energy, facility, procurement ed ESG"
              ]
            }
          },
          {
            "tipo": "cta_finale",
            "heading": {
              "it": "Gestire meglio ogni sede, senza perdere il controllo della rete."
            },
            "text": {
              "it": "Partiamo da bollette, sedi e contratti esistenti. Analizziamo consumi, costi e criticità operative e costruiamo una gestione più competitiva, veloce e coerente tra tutti i punti di consumo."
            }
          }
        ]
      }
    }
  ],
  "partners": [
    {
      "name": "Unoenergy",
      "role": "Forniture energia e gas per imprese e clienti business"
    },
    {
      "name": "Unoenergy Saving",
      "role": "Efficienza, fotovoltaico, storage, colonnine e CER"
    },
    {
      "name": "Unoenergy Green",
      "role": "Energia rinnovabile, certificati e tracciabilità"
    },
    {
      "name": "A2A · PMI",
      "role": "Forniture luce e gas per piccole e medie imprese"
    },
    {
      "name": "A2A · Grandi Clienti",
      "role": "Soluzioni energetiche per consumi complessi"
    },
    {
      "name": "LifeGate Energy",
      "role": "Forniture da fonti rinnovabili"
    },
    {
      "name": "FGB",
      "role": "PPA, Garanzie d'Origine, RECs e supporto LEED"
    },
    {
      "name": "A&P / Alberici",
      "role": "Competenze tecniche e progetti di efficienza"
    },
    {
      "name": "QFORT",
      "role": "Serramenti e involucro edilizio"
    },
    {
      "name": "MAG",
      "role": "Brokeraggio e consulenza assicurativa"
    },
    {
      "name": "Marazzato",
      "role": "Servizi ambientali, bonifiche, serbatoi e cantieri"
    }
  ],
  "footer": {
    "legal": {
      "it": "ETHIC ENERGY è una business unit di RR Solutions srl",
      "en": "ETHIC ENERGY is a business unit of RR Solutions srl"
    },
    "piva": {
      "it": "RR Solutions srl · Sede legale: Via Francesco Olgiati n. 26, Milano · Cap. Soc. € 10.000,00 i.v. · Registro Imprese di Milano Monza Brianza e Lodi · CF e P.IVA 02582720997 · R.E.A. MI-2677808",
      "en": "RR Solutions srl · Registered office: Via Francesco Olgiati n. 26, Milan · Share capital € 10,000.00 fully paid-in · Milan Monza Brianza and Lodi Companies Register · Tax code and VAT no. 02582720997 · R.E.A. MI-2677808"
    },
    "note": {
      "it": "Consulenza + Delivery: un solo punto di regia per energia, efficienza e gestione operativa.",
      "en": "Consulting + Delivery: a single coordination point for energy, efficiency and operational management."
    }
  },
  "seo": {
    "title": {
      "it": "ETHIC ENERGY | Consulenza energia B2B",
      "en": "ETHIC ENERGY | B2B Energy Consulting"
    },
    "description": {
      "it": "Analizziamo consumi, contratti e costi per guidare procurement, efficienza e gestione del rischio energetico per aziende e fondi.",
      "en": "We analyze consumption, contracts, and costs to guide procurement, efficiency, and energy risk management for companies and investment funds."
    },
    "keywords": {
      "it": "consulenza energia B2B, procurement energia, gestione energia, contratti energia, efficienza energetica, rischio energetico, PPA energia, fondi immobiliari",
      "en": "B2B energy consulting, energy procurement, energy management, energy contracts, energy efficiency, energy risk, PPA energy, real estate funds"
    }
  },
  "macroaree": {
    "energy-management": {
      "image": "https://images.unsplash.com/photo-1729972869920-b98a5b7002fe?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "num": "01",
      "title": {
        "it": "Gestione Energia & Approvvigionamento"
      },
      "payoff": {
        "it": "Acquistare e gestire meglio l'energia."
      },
      "intro": {
        "it": "Ethic affianca imprese e organizzazioni nella gestione completa delle forniture energetiche: analisi dei consumi e dei contratti, confronto del mercato, selezione dei fornitori compatibili, strategia di prezzo e presidio operativo nel tempo. L'obiettivo non è trovare una singola offerta, ma costruire una strategia di approvvigionamento coerente con consumi, budget, profilo di rischio, modalità di pagamento e reali esigenze operative."
      },
      "seo_title": {
        "it": "Energy Management & Procurement per imprese",
        "en": "Energy Management & Procurement for businesses"
      },
      "seo_desc": {
        "it": "Forniture luce e gas, supplier fit, strategie Fix/Flex/Mix, PPA, controllo bollette e gestione continuativa POD/PDR per aziende e portafogli multi-sito.",
        "en": "Electricity and gas supply, supplier fit, Fix/Flex/Mix strategies, PPAs, bill control and ongoing POD/PDR management for companies and multi-site portfolios."
      },
      "charts": [
        {
          "id": "analisi-controllo",
          "num": "01",
          "stato": "pubblicato",
          "title": {
            "it": "Analisi & Controllo"
          },
          "sub": {
            "it": "Prima di andare sul mercato, ricostruiamo il quadro reale: consumi, contratti, condizioni economiche, profilo commerciale, credit check e gestione dei punti di fornitura."
          },
          "services": [
            {
              "slug": "analisi-forniture-profilo-energetico",
              "title": {
                "it": "Analisi forniture e profilo energetico"
              },
              "desc": {
                "it": "Ricostruzione della situazione corrente attraverso bollette, contratti, consumi, potenze, scadenze e condizioni economiche. L'obiettivo è capire dove si trova realmente il problema: prezzo, struttura contrattuale, profilo di consumo, potenze, scadenze o gestione operativa."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "profilazione-commerciale-fornitori",
              "title": {
                "it": "Profilazione commerciale e compatibilità con i fornitori"
              },
              "desc": {
                "it": "Costruiamo il profilo di attivabilità commerciale del cliente considerando modalità e termini di pagamento, affidabilità creditizia, eventuali garanzie e requisiti degli operatori. Gare e negoziazioni si concentrano sui fornitori realmente compatibili; l'accettazione finale resta soggetta alle policy del singolo fornitore."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "controllo-bollette-audit-fatturazione",
              "title": {
                "it": "Controllo bollette e audit fatturazione"
              },
              "desc": {
                "it": "Verifica periodica delle fatture di energia elettrica e gas: condizioni applicate, componenti economiche, consumi, anomalie, scostamenti e coerenza con il contratto. Il controllo può essere attivato anche come servizio continuativo."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "gestione-continuativa-forniture",
              "title": {
                "it": "Gestione continuativa delle forniture"
              },
              "desc": {
                "it": "Presidio operativo dopo l'attivazione: nuove forniture e nuovi POD/PDR, variazioni di potenza, subentri e volture, cessazioni, inserimento o uscita di siti, scadenze, rinnovi, rinegoziazioni e modifiche del profilo di consumo, coordinati con venditori e distributori."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "procurement-mercato",
          "num": "02",
          "stato": "pubblicato",
          "title": {
            "it": "Procurement & Mercato"
          },
          "sub": {
            "it": "Dopo l'analisi definiamo la struttura di acquisto e mettiamo in concorrenza le controparti compatibili, scegliendo prezzo, formula contrattuale e timing più coerenti con il cliente."
          },
          "services": [
            {
              "slug": "fornitura-energia-elettrica-gas",
              "title": {
                "it": "Fornitura energia elettrica e gas"
              },
              "desc": {
                "it": "Accesso a più operatori per PMI, grandi clienti e portafogli multi-sito. Ethic confronta prezzo, struttura contrattuale, condizioni di pagamento, compatibilità commerciale e capacità di servizio, coordinando negoziazione, attivazione e gestione successiva."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "strategie-fix-flex-mix",
              "title": {
                "it": "Strategie FIX, FLEX e MIX"
              },
              "desc": {
                "it": "Prezzo fisso, indicizzato o combinazioni miste in funzione del profilo di consumo, dell'orizzonte temporale, del budget e della propensione al rischio. Dove coerente, possono essere valutate strutture con fixing progressivi e percentuali differenziate."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "gare-benchmark-negoziazione",
              "title": {
                "it": "Gare, benchmark e negoziazione"
              },
              "desc": {
                "it": "Raccolta e normalizzazione delle offerte, shortlist dei fornitori compatibili, confronto a parità di perimetro, benchmark delle condizioni e negoziazione a supporto della decisione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "trading-desk-fixing-rischio",
              "title": {
                "it": "Trading desk, fixing e gestione del rischio"
              },
              "desc": {
                "it": "Supporto alle strategie di acquisto per clienti e profili compatibili: monitoraggio del mercato, individuazione delle finestre di fixing, coperture progressive e gestione della quota esposta, calibrate sul contratto e sul profilo del cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "ppa-power-purchase-agreement",
              "title": {
                "it": "PPA — Power Purchase Agreement"
              },
              "desc": {
                "it": "Valutazione e strutturazione di accordi di approvvigionamento di medio-lungo periodo da fonte rinnovabile per clienti con volumi e profili compatibili: durata, struttura di prezzo, volumi, profilo di produzione/consumo e attributi ambientali. Dove applicabile, valutazione di configurazioni onsite e offsite."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "green-traceability",
          "num": "03",
          "stato": "pubblicato",
          "title": {
            "it": "Green & Traceability"
          },
          "sub": {
            "it": "Per i clienti che vogliono integrare obiettivi ambientali e reporting nella strategia di approvvigionamento, strutturiamo strumenti rinnovabili e sistemi di tracciabilità coerenti e verificabili."
          },
          "services": [
            {
              "slug": "rinnovabili-certificati-tracciabilita",
              "title": {
                "it": "Energia rinnovabile, certificati e tracciabilità"
              },
              "desc": {
                "it": "Approvvigionamento da fonti rinnovabili, Garanzie d'Origine e altri attributi energetici, con supporto nella scelta degli strumenti coerenti con obiettivi ambientali, reporting e requisiti di certificazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "tracciamento-energia-granularita",
              "title": {
                "it": "Tracciamento dell'energia e granularità temporale"
              },
              "desc": {
                "it": "Tracciamento e matching della provenienza dell'energia con maggiore granularità temporale, dove applicabile, per aumentare la verificabilità delle dichiarazioni e la qualità del reporting."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "combustibili-lubrificanti-fluidi",
          "num": "04",
          "stato": "bozza",
          "title": {
            "it": "Combustibili, Lubrificanti & Fluidi Tecnici"
          },
          "sub": {
            "it": "Per le attività che richiedono prodotti energetici e tecnici oltre a elettricità e gas di rete, Ethic supporta l'approvvigionamento di combustibili, lubrificanti e fluidi tecnici con una gestione coordinata delle esigenze operative."
          },
          "services": [
            {
              "slug": "prodotti-petroliferi-gpl",
              "title": {
                "it": "Prodotti petroliferi e GPL"
              },
              "desc": {
                "it": "Supporto all'approvvigionamento di prodotti petroliferi e GPL per attività industriali, logistiche, immobiliari o operative che utilizzano combustibili diversi dall'energia elettrica e dal gas di rete."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "lubrificanti",
              "title": {
                "it": "Lubrificanti"
              },
              "desc": {
                "it": "Supporto alla fornitura di lubrificanti per applicazioni industriali, automotive, logistiche e impiantistiche, selezionati in funzione delle specifiche tecniche, delle condizioni operative e delle esigenze di continuità della fornitura."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "urea-adblue",
              "title": {
                "it": "Urea / AdBlue"
              },
              "desc": {
                "it": "Fornitura di soluzioni a base di urea per sistemi SCR e altre applicazioni che richiedono la riduzione delle emissioni di NOx, con gestione dell'approvvigionamento coerente con volumi, frequenza di utilizzo e necessità operative."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        }
      ],
      "trasversale": null,
      "cta_finale": {
        "heading": {
          "it": "Inizia dall'analisi. Non da un'offerta."
        },
        "text": {
          "it": "Raccontaci il tuo profilo energetico o inviaci una bolletta. Il primo obiettivo è capire dove esiste valore: fornitura, struttura contrattuale, controllo, gestione o strategia di acquisto."
        },
        "primary": {
          "it": "Richiedi un'analisi"
        },
        "secondary": {
          "it": "Invia una bolletta"
        }
      }
    },
    "efficiency-transition": {
      "image": "https://images.unsplash.com/photo-1776860154052-d91c90b25c59?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "num": "02",
      "title": {
        "it": "Efficienza & Transizione Energetica"
      },
      "payoff": {
        "it": "Consumare meno, produrre meglio, rendere più efficienti impianti e processi."
      },
      "intro": {
        "it": "Ethic parte dall'analisi dei consumi, degli impianti e degli obiettivi del cliente per individuare gli interventi con il miglior equilibrio tra risparmio, investimento, affidabilità, incentivi e tempi di ritorno. Per ogni tecnologia e fornitura selezioniamo, all'interno del nostro ecosistema, il partner tecnico più adatto per competenze, dimensione, tecnologia, area geografica, capacità operativa e caratteristiche del progetto. Ethic mantiene la regia del percorso, coordina partner e professionisti e accompagna il cliente fino all'implementazione e, dove previsto, alla gestione continuativa."
      },
      "seo_title": {
        "it": "Efficiency & Energy Transition",
        "en": "Efficiency & Energy Transition"
      },
      "seo_desc": {
        "it": "Diagnosi energetiche, fotovoltaico, storage, colonnine di ricarica, CER, Conto Termico, pratiche GSE e involucro edilizio: efficienza dalla diagnosi all'execution.",
        "en": "Energy assessments, solar photovoltaic, storage, charging stations, CER, Thermal Account, GSE applications and building envelope: efficiency from diagnosis to execution."
      },
      "charts": [
        {
          "id": "analisi-progettazione",
          "num": "01",
          "stato": "pubblicato",
          "title": {
            "it": "Analisi & Progettazione Energetica"
          },
          "sub": {
            "it": "Capire dove intervenire e costruire un percorso di efficientamento coerente con consumi, impianti e obiettivi economici."
          },
          "services": [
            {
              "slug": "diagnosi-energetica",
              "title": {
                "it": "Diagnosi energetica"
              },
              "desc": {
                "it": "Analisi tecnica dei consumi, degli utilizzi e degli impianti per individuare inefficienze, priorità di intervento e opportunità di riduzione dei consumi. La diagnosi diventa la base per definire investimenti, incentivi e una roadmap energetica coerente con gli obiettivi del cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "progetti-integrati-efficientamento",
              "title": {
                "it": "Progetti integrati di efficientamento"
              },
              "desc": {
                "it": "Quando il risultato richiede più interventi, Ethic costruisce e coordina un progetto integrato combinando tecnologie, fornitori, professionisti e pratiche. Per ogni componente del progetto selezioniamo il partner più adatto al profilo del cliente e manteniamo la regia fino alla fase di execution."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "produzione-autoconsumo-mobilita",
          "num": "02",
          "stato": "pubblicato",
          "title": {
            "it": "Produzione, Autoconsumo & Mobilità Elettrica"
          },
          "sub": {
            "it": "Produrre energia, aumentare l'autoconsumo e integrare nuovi utilizzi elettrici in modo coerente con il profilo del cliente."
          },
          "services": [
            {
              "slug": "fotovoltaico",
              "title": {
                "it": "Fotovoltaico"
              },
              "desc": {
                "it": "Analisi di consumi, superfici disponibili, producibilità, quota di autoconsumo, investimento e ritorno economico per definire la soluzione fotovoltaica più coerente con il profilo del cliente. Ethic seleziona il partner tecnico più adatto per tecnologia, dimensione, area geografica e caratteristiche del progetto e coordina il percorso dalla valutazione preliminare all'implementazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "batterie-accumulo",
              "title": {
                "it": "Batterie e sistemi di accumulo"
              },
              "desc": {
                "it": "Valutazione di sistemi di accumulo abbinati al fotovoltaico o a specifici profili di consumo, con l'obiettivo di aumentare l'autoconsumo, gestire i picchi e utilizzare in modo più efficiente l'energia prodotta. Ethic seleziona il partner tecnico più adatto in funzione della tecnologia, della taglia, del profilo di utilizzo e delle caratteristiche del sito e ne coordina l'implementazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "cer-comunita-energetiche",
              "title": {
                "it": "Comunità Energetiche Rinnovabili — CER"
              },
              "desc": {
                "it": "Valutazione, configurazione e supporto allo sviluppo o all'ingresso in Comunità Energetiche Rinnovabili e altri schemi di condivisione dell'energia: analisi dei soggetti coinvolti, degli impianti, dei consumi, dei flussi energetici e delle opportunità economiche. Ethic seleziona e coordina i partner e le competenze specialistiche più adatte alla configurazione specifica."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "colonnine-ricarica",
              "title": {
                "it": "Colonnine di ricarica"
              },
              "desc": {
                "it": "Valutazione, progettazione e installazione di infrastrutture di ricarica per aziende, patrimoni immobiliari, hospitality, condomini, flotte e parcheggi, con possibile integrazione con fotovoltaico, accumulo e gestione energetica. Ethic seleziona il partner tecnico più adatto in funzione di potenza disponibile, numero di punti di ricarica, tipologia di utilizzo, sistema di gestione e caratteristiche del sito e coordina l'implementazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "impianti-involucro",
          "num": "03",
          "stato": "pubblicato",
          "title": {
            "it": "Impianti & Involucro"
          },
          "sub": {
            "it": "Ridurre i consumi intervenendo direttamente sugli impianti e sulle prestazioni dell'edificio."
          },
          "services": [
            {
              "slug": "pompe-di-calore",
              "title": {
                "it": "Pompe di calore"
              },
              "desc": {
                "it": "Valutazione, progettazione e realizzazione di sistemi a pompa di calore per riscaldamento, raffrescamento e produzione di acqua calda, con analisi dei consumi, dell'impianto esistente, delle condizioni operative e dell'integrazione con fotovoltaico e altri sistemi energetici. Ethic seleziona il partner tecnico più adatto alla tipologia di edificio, potenza, tecnologia e complessità del progetto e coordina il percorso fino all'implementazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "impianti-termici-generazione-calore",
              "title": {
                "it": "Impianti termici e generazione del calore"
              },
              "desc": {
                "it": "Riqualificazione, sostituzione o rifacimento di centrali termiche, caldaie e impianti a gas, valutando efficienza, affidabilità, costi di esercizio e compatibilità con le esigenze dell'edificio o del processo. Ethic seleziona il partner tecnico più adatto in funzione della tipologia di impianto, della potenza, della tecnologia e della complessità dell'intervento e ne coordina l'execution."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "involucro-edilizio-serramenti",
              "title": {
                "it": "Involucro edilizio e serramenti"
              },
              "desc": {
                "it": "Interventi sull'involucro edilizio e sui serramenti finalizzati a ridurre le dispersioni, migliorare comfort e prestazioni energetiche e contribuire alla riqualificazione complessiva dell'edificio, anche in relazione agli incentivi disponibili. Ethic seleziona il partner tecnico più adatto per tipologia di edificio, prestazioni richieste, materiali e caratteristiche dell'intervento e coordina il percorso di implementazione."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "manutenzione-conduzione-ottimizzazione",
              "title": {
                "it": "Manutenzione, conduzione e ottimizzazione degli impianti"
              },
              "desc": {
                "it": "Programmi di manutenzione, conduzione e interventi di ottimizzazione finalizzati a preservare efficienza, affidabilità e continuità di esercizio degli impianti nel tempo. Ethic seleziona il partner specialistico più adatto in funzione della tipologia di impianto, della complessità del sito e del livello di presidio richiesto e coordina il servizio verso il cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "incentivi-pratiche",
          "num": "04",
          "stato": "pubblicato",
          "title": {
            "it": "Incentivi & Pratiche"
          },
          "sub": {
            "it": "Individuare gli strumenti agevolativi applicabili e coordinare il percorso tecnico-amministrativo collegato agli interventi."
          },
          "services": [
            {
              "slug": "incentivi-conto-termico-gse",
              "title": {
                "it": "Incentivi, Conto Termico & pratiche GSE"
              },
              "desc": {
                "it": "Valutazione degli incentivi applicabili agli interventi energetici e gestione o coordinamento del relativo percorso tecnico-amministrativo: Conto Termico, pratiche GSE e altri strumenti agevolativi disponibili, dalla verifica preliminare dei requisiti fino alla documentazione necessaria e alla conclusione della pratica. Ethic attiva, quando necessario, i professionisti e i partner specialistici più adatti alla specifica misura e all'intervento collegato."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "efficienza-combustibili-chimica",
          "num": "05",
          "stato": "pubblicato",
          "title": {
            "it": "Efficienza dei Combustibili & Soluzioni Chimiche"
          },
          "sub": {
            "it": "Migliorare combustione, prestazioni operative e utilizzo dei combustibili attraverso soluzioni specialistiche selezionate sullo specifico impianto."
          },
          "services": [
            {
              "slug": "additivi-chimica-combustibili",
              "title": {
                "it": "Additivi e chimica per l'efficienza dei combustibili"
              },
              "desc": {
                "it": "Additivi e trattamenti specialistici per combustibili finalizzati a migliorare efficienza di combustione, stabilità, pulizia e prestazioni operative. Ogni applicazione viene valutata tecnicamente in funzione del combustibile, dell'impianto e delle condizioni di esercizio. Ethic seleziona la soluzione e il partner specialistico più adatti al caso e coordina il percorso di test, implementazione e monitoraggio."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        }
      ],
      "trasversale": {
        "title": {
          "it": "Le tecnologie funzionano meglio quando lavorano insieme."
        },
        "text": {
          "it": "Fotovoltaico, accumulo, pompe di calore, mobilità elettrica, impianti termici e involucro vengono valutati come parti di un unico sistema energetico, non come interventi indipendenti. Ethic costruisce la combinazione più coerente con il profilo del cliente, seleziona per ogni tecnologia il partner tecnico più adatto e mantiene la regia dell'implementazione e dell'integrazione tra i diversi interventi."
        }
      },
      "cta_finale": {
        "heading": {
          "it": "Inizia dalla diagnosi. Non da un'offerta."
        },
        "text": {
          "it": ""
        },
        "primary": {
          "it": "Richiedi un'analisi"
        },
        "secondary": {
          "it": "Parla con Ethic"
        }
      }
    },
    "technical-risk": {
      "image": "https://images.unsplash.com/photo-1762146828422-50a8bd416d3c?fm=jpg&q=80&w=1600&auto=format&fit=crop",
      "num": "03",
      "title": {
        "it": "Soluzioni Tecniche, Ambientali & Gestione del Rischio"
      },
      "payoff": {
        "it": "Competenze specialistiche per impianti, ambiente, rischio e operatività."
      },
      "intro": {
        "it": "Molte esigenze del cliente non si esauriscono nella fornitura energetica o nell'intervento di efficientamento. Ethic integra competenze tecniche, ambientali, assicurative e specialistiche, selezionando di volta in volta il partner più adatto al profilo del cliente e alla specifica esigenza. Manteniamo la regia della relazione e, quando richiesto, coordiniamo anche la fase di implementazione."
      },
      "seo_title": {
        "it": "Technical, Environmental & Risk Solutions",
        "en": "Technical, Environmental & Risk Solutions"
      },
      "seo_desc": {
        "it": "Project coordination, affiancamento Energy Manager, supporto LEED, assicurazioni, bonifiche e servizi ambientali per impianti, immobili e cantieri.",
        "en": "Project coordination, Energy Manager support, LEED support, insurance, remediation and environmental services for plants, real estate and construction sites."
      },
      "charts": [
        {
          "id": "coordinamento-consulenza",
          "num": "01",
          "stato": "pubblicato",
          "title": {
            "it": "Coordinamento di Progetto & Consulenza Specialistica"
          },
          "sub": {
            "it": "Coordinare competenze, professionisti e attività specialistiche fino alla concreta implementazione del progetto."
          },
          "services": [
            {
              "slug": "coordinamento-progetto-implementazione",
              "title": {
                "it": "Coordinamento di progetto e implementazione"
              },
              "desc": {
                "it": "Per progetti che coinvolgono più soggetti, Ethic può assumere una funzione di regia tra cliente, progettisti, tecnici, installatori, fornitori e partner specialistici. Coordiniamo flussi informativi, priorità, cronoprogramma e avanzamento delle attività fino alla fase di implementazione, mantenendo un unico presidio verso il cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "affiancamento-energy-manager",
              "title": {
                "it": "Affiancamento a Energy Manager e team interni"
              },
              "desc": {
                "it": "Ethic lavora al fianco di Energy Manager, procurement, facility manager, asset/property manager e team tecnici, portando profondità di mercato, specialisti verticali, confronto delle soluzioni e supporto all'execution, senza sovrapporsi alla governance interna del cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "supporto-leed-certificazioni",
              "title": {
                "it": "Supporto LEED e altri protocolli di certificazione"
              },
              "desc": {
                "it": "Ethic seleziona e coordina le competenze specialistiche necessarie per requisiti energetici e ambientali connessi a LEED e ad altri protocolli di certificazione degli edifici, inclusa la raccolta e l'organizzazione della documentazione energetica richiesta."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "assicurazioni-rischio",
          "num": "02",
          "stato": "pubblicato",
          "title": {
            "it": "Soluzioni Assicurative & Gestione del Rischio"
          },
          "sub": {
            "it": "Coperture costruite sulle caratteristiche delle forniture, degli impianti e degli interventi, attraverso broker assicurativi specializzati."
          },
          "services": [
            {
              "slug": "soluzioni-parametriche-consumi",
              "title": {
                "it": "Soluzioni parametriche su consumi e variabili energetiche"
              },
              "desc": {
                "it": "Dove applicabile, Ethic supporta la lettura dei dati energetici e la definizione dei parametri tecnici dell'esigenza. L'eventuale soluzione assicurativa è valutata e intermediata dal broker abilitato."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "coperture-impianti-energetici",
              "title": {
                "it": "Coperture per impianti energetici"
              },
              "desc": {
                "it": "Ethic mette a disposizione informazioni tecniche su impianti, caratteristiche operative e rischi da presidiare. La valutazione e l'intermediazione delle eventuali coperture sono svolte dal broker assicurativo abilitato."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "coperture-interventi-manutenzioni",
              "title": {
                "it": "Coperture per interventi e manutenzioni"
              },
              "desc": {
                "it": "Ethic supporta la definizione del perimetro tecnico dell'intervento e delle relative caratteristiche operative. Il broker abilitato valuta e struttura l'eventuale copertura assicurativa."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "coperture-rischi-energetici",
              "title": {
                "it": "Coperture su specifici rischi energetici"
              },
              "desc": {
                "it": "Per esigenze connesse a forniture, impianti o variabili energetiche, Ethic fornisce al broker gli elementi tecnici utili alla valutazione. Ogni proposta o soluzione assicurativa resta di competenza esclusiva del broker abilitato."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ],
          "note": {
            "it": "Ethic analizza insieme al cliente le caratteristiche tecniche, energetiche e operative dell'esigenza e mette a disposizione del broker assicurativo specializzato gli elementi utili alla valutazione delle possibili coperture. La valutazione assicurativa, la proposta, l'intermediazione e la finalizzazione delle coperture sono svolte esclusivamente dal broker abilitato."
          },
          "note_footer": {
            "it": "Ethic Energy non svolge attività di distribuzione o intermediazione assicurativa. Le eventuali soluzioni assicurative sono valutate, proposte e intermediate esclusivamente da broker assicurativi abilitati e regolarmente iscritti al Registro Unico degli Intermediari (RUI). Ethic Energy svolge esclusivamente attività di supporto tecnico con riferimento alle esigenze energetiche, impiantistiche e operative del cliente."
          },
          "label": {
            "it": "Tramite broker assicurativi abilitati"
          }
        },
        {
          "id": "servizi-ambientali-siti",
          "num": "03",
          "stato": "pubblicato",
          "title": {
            "it": "Servizi Ambientali & Gestione dei Siti"
          },
          "sub": {
            "it": "Servizi specialistici per la gestione ambientale e operativa di immobili, impianti, siti produttivi e cantieri."
          },
          "services": [
            {
              "slug": "bonifica-gestione-serbatoi",
              "title": {
                "it": "Bonifica e gestione serbatoi"
              },
              "desc": {
                "it": "Bonifica, pulizia, messa in sicurezza, verifica e gestione di serbatoi e infrastrutture correlate. Ethic individua e coordina il partner specialistico più adatto in funzione della tipologia di impianto, della sostanza contenuta e delle caratteristiche del sito."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "fosse-biologiche-servizi-ambientali",
              "title": {
                "it": "Fosse biologiche e servizi ambientali"
              },
              "desc": {
                "it": "Servizi di spurgo, pulizia, gestione e intervento su fosse biologiche e altre infrastrutture ambientali per condomini, hospitality, immobili e siti produttivi, attraverso operatori specialistici selezionati da Ethic."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "servizi-ambientali-cantieri",
              "title": {
                "it": "Servizi ambientali per cantieri"
              },
              "desc": {
                "it": "Servizi ambientali e operativi a supporto di lavori e cantieri, con selezione e coordinamento dei partner specialistici in funzione delle caratteristiche dell'intervento e del sito."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            },
            {
              "slug": "analisi-acque-legionella",
              "title": {
                "it": "Analisi acque & Legionella"
              },
              "desc": {
                "it": "Analisi e monitoraggio della qualità delle acque e supporto alle attività di prevenzione e controllo del rischio Legionella attraverso laboratori e professionisti specialistici selezionati da Ethic. Il servizio è particolarmente rilevante per condomini, hospitality, patrimoni immobiliari e strutture con impianti idrici centralizzati."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        },
        {
          "id": "pratiche-agevolazioni-fiscalita",
          "num": "04",
          "stato": "pubblicato",
          "title": {
            "it": "Pratiche, Agevolazioni & Fiscalità Energetica"
          },
          "sub": {
            "it": "Competenze specialistiche per verifiche, agevolazioni e adempimenti che richiedono un presidio tecnico-amministrativo dedicato."
          },
          "services": [
            {
              "slug": "verifica-accise-carburanti",
              "title": {
                "it": "Verifica accise carburanti"
              },
              "desc": {
                "it": "Analisi specialistica del trattamento delle accise applicate ai carburanti e verifica dei presupposti per eventuali agevolazioni, recuperi o correzioni. Ethic individua e attiva le competenze specialistiche necessarie e coordina il percorso con il cliente."
              },
              "partner": "",
              "cluster": "",
              "stato": "pubblicato"
            }
          ]
        }
      ],
      "trasversale": null,
      "cta_finale": {
        "heading": {
          "it": "Partiamo dall'esigenza. Attiviamo la competenza giusta."
        },
        "text": {
          "it": ""
        },
        "primary": {
          "it": "Parla con Ethic"
        },
        "secondary": {
          "it": ""
        }
      }
    }
  }
};

export default defaultContent;
